import * as Yup from 'yup';
import personVehicleRegistrationSchema from './personVehicleRegistrationSchema';

export default personVehicleRegistrationSchema.shape({
  PartyType: Yup.string().nullable().required('Select a party type'),
  ptsParentID: Yup.number().nullable().required('Select a person or place'),
});
